import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Nav, Navbar as BSNavbar, Badge } from 'react-bootstrap';
import { ShoppingCart, User, Menu, X } from 'lucide-react';

const Navbar = () => {
  const [cartCount] = useState(0);
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      {/* Top promotional bar */}
      <div className="bg-dark text-white py-2">
        <Container>
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <span className="small">On your first order</span>
            <span className="badge bg-warning text-dark px-3 py-2">50% OFF</span>
            <span className="small">For all products buy now get the offer</span>
          </div>
        </Container>
      </div>

      {/* Main navigation */}
      <BSNavbar 
        expand="lg" 
        className="py-3 shadow-sm"
        expanded={expanded}
        onToggle={() => setExpanded(!expanded)}
        style={{ background: 'linear-gradient(to right, #FFFFFF, #1d384e)' }}
      >
        <Container>
          <BSNavbar.Brand as={Link} to="/" className="d-flex align-items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_modern-bs5-site/artifacts/eelqdwqk_ChatGPT%20Image%20Nov%2010%2C%202025%2C%2011_44_19%20PM.png" 
              alt="FURRMAA Logo" 
              style={{ height: '50px', width: 'auto', marginRight: '10px' }}
            />
            <span className="fs-3 fw-bold" style={{ color: '#001F3F' }}>
              FURRMAA
            </span>
          </BSNavbar.Brand>
          
          <BSNavbar.Toggle aria-controls="basic-navbar-nav">
            {expanded ? <X size={24} /> : <Menu size={24} />}
          </BSNavbar.Toggle>
          
          <BSNavbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-lg-center">
              <Nav.Link as={Link} to="/" className="mx-2">Home</Nav.Link>
              <Nav.Link as={Link} to="/products" className="mx-2">Products</Nav.Link>
              <Nav.Link as={Link} to="/furrmap" className="mx-2">Furrmap</Nav.Link>
              <Nav.Link as={Link} to="/about" className="mx-2">About</Nav.Link>
              <Nav.Link as={Link} to="/contact" className="mx-2">Contact</Nav.Link>
              
              <div className="d-flex align-items-center ms-lg-3 mt-2 mt-lg-0">
                <Link to="/account" className="btn btn-link text-dark position-relative me-2">
                  <User size={24} />
                </Link>
                <Link to="/cart" className="btn btn-link text-dark position-relative">
                  <ShoppingCart size={24} />
                  {cartCount > 0 && (
                    <Badge bg="danger" className="position-absolute top-0 start-100 translate-middle">
                      {cartCount}
                    </Badge>
                  )}
                </Link>
              </div>
            </Nav>
          </BSNavbar.Collapse>
        </Container>
      </BSNavbar>
    </>
  );
};

export default Navbar;